import NamePage from "./NamePage";

const PageHeader = ({ name, subName, value, setValue, item, userMe }) => {
  return (
    <NamePage
      name={name}
      subName={subName}
      // component={
      //   <Box sx={{ maxWidth: "180px" }}>
      //     <SelectComp
      //       input={
      //         <OutlinedInput
      //           startAdornment={
      //             <InputAdornment position="start">
      //               <Typography
      //                 fontWeight="bold"
      //                 sx={{
      //                   borderRight: "1px solid var(--grey)",
      //                   pr: "12px",
      //                   color: "var(--black)",
      //                   fontSize: "12px",
      //                 }}
      //               >
      //                 Kho
      //               </Typography>
      //             </InputAdornment>
      //           }
      //         />
      //       }
      //       userMe={userMe}
      //       value={value}
      //       setValue={setValue}
      //       item={item}
      //       disabled={userMe?.role?.name !== userRoleType.superAdmin}
      //     />
      //   </Box>
      // }
    />
  );
};

export default PageHeader;
